export function ownerToEntityRef(owner: string): string {
  return owner.startsWith('teams-')
    ? `group:default/${owner}`
    : `user:default/${owner}`;
}
